import { useEffect, useState } from "react";
import { useMediaQuery } from "usehooks-ts";

interface DeviceType {
  isIOS: boolean;
  isAndroid: boolean;
  isDesktop: boolean;
}

const useDeviceType = (): DeviceType => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [deviceType, setDeviceType] = useState<DeviceType>({
    isIOS: false,
    isAndroid: false,
    isDesktop: false
  });

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const isIOS = /iPhone/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);

    setDeviceType({
      isIOS: isIOS,
      isAndroid: isAndroid,
      isDesktop: !(isMobile || (isIOS && isAndroid))
    });
  }, [isMobile]);

  return deviceType;
};

export default useDeviceType;
